import './index.css'

import { initSentry, Sentry } from './sentry'

// Initialize Sentry before anything else
initSentry()

import React from 'react'

import { loader } from '@monaco-editor/react'
import {
	QueryCache,
	QueryClient,
	QueryClientProvider,
} from '@tanstack/react-query'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import { ConfigProvider } from '@/contexts/ConfigContext'

import App from './App'

// prefetch monaco from cdn for later use
Promise.all([loader.init(), import('@asta/lang-ide')]).then(([monaco, ide]) => {
	ide.registerFlowsSyntax(monaco)
	ide.registerRulesLanguage(monaco)
	ide.registerSpellcheckSyntax(monaco)
})

const queryCache = new QueryCache()
const client = new QueryClient({
	queryCache,
	defaultOptions: {
		queries: {
			// queries must opt in to caching
			staleTime: 0,
		},
	},
})
const root = ReactDOM.createRoot(
	document.getElementById('root') as HTMLElement,
	{
		onRecoverableError(error, errorInfo) {
			console.error(error)
			console.error(errorInfo)
			Sentry.captureException(error, { extra: { errorInfo } })
		},
	}
)

// The React team claims that strict mode gets disabled in production, but I've
// had past experiences where double-renders still occurred in prod. By doing a
// check ourselves, we ensure strict mode is only ever enabled in dev.
const StrictMode =
	process.env.NODE_ENV !== 'production' ? React.StrictMode : React.Fragment

root.render(
	<StrictMode>
		<QueryClientProvider client={client}>
			<ConfigProvider>
				<BrowserRouter>
					<App />
				</BrowserRouter>
			</ConfigProvider>
		</QueryClientProvider>
	</StrictMode>
)
